// const ProjectsList

import { createContext, useContext, useState } from "react";
import { useElementTop } from "../utils/useRotateOnScroll";

export const ProjectsListContext = createContext(null);

export const useProjectsList = () => useContext(ProjectsListContext);

interface filterDataType {
	title: string;
	keywords?: string[];
}
export const ProjectsListContextProvider = ({ children }) => {
	const [allProjects, setAllProjects] = useState([]);
	const [filterData, setFilterData] = useState<filterDataType[]>([]);
	const [filteredProjects, setFilteredProjects] = useState([]);
	const [activeFilter, setActiveFilter] = useState<filterDataType>({
		title: "all-projects",
	});

	const fetchProjects = (projectsData) => {
		setAllProjects(projectsData);
		setFilteredProjects(projectsData);
		extractFilters(projectsData);
	};

	const extractFilters = (projectsData) => {
		console.log(projectsData);
		setFilterData([
			{
				title: "all-projects",
			},
			{
				title: "Client's work",
				keywords: ["Client-Requested", "Client-work", "Self Employed"],
			},
			{ title: "Personal project", keywords: ["Personal"] },
		]);
	};

	const filterProjects = () => {
		if (activeFilter.title == "all-projects") {
			setFilteredProjects(allProjects);

			return;
		} else {
			const filteredProjectArray = [];

			let matchFound = false;
			// const filtered =
			allProjects.map((project) => {
				matchFound = false;

				activeFilter.keywords.map((word) => {
					if (!matchFound) {
						if (project?.source_categories?.includes(word)) {
							filteredProjectArray.push(project);

							matchFound = true;

							return;
						} else {
						}
					}
				});
			});

			setFilteredProjects(filteredProjectArray);
		}
	};

	const selectFilter = (
		selected: filterDataType,
		menuVisible: boolean,
		toggle: () => void
	): void => {
		setActiveFilter(selected);

		if (menuVisible) {
			toggle();
		}
	};

	// ---
	const { elementRef: projectSectRef, myElementIsVisible } = useElementTop();

	return (
		<ProjectsListContext.Provider
			value={{
				fetchProjects,
				allProjects,
				filteredProjects,
				filterData,
				setFilterData,
				activeFilter,
				filterProjects,
				selectFilter,
				// ---
				projectSectRef,
				myElementIsVisible,
			}}
		>
			{children}
		</ProjectsListContext.Provider>
	);
};
